import { Link } from 'react-router-dom';

interface LogoProps {
  to?: string;
  variant?: 'dark' | 'light';
  size?: 'sm' | 'md';
  showName?: boolean;
}

export default function Logo({ to = '/', variant = 'dark', size = 'md', showName = true }: LogoProps) {
  const markSize = size === 'sm' ? 'w-8 h-8 rounded-[10px]' : 'w-10 h-10 rounded-xl';
  const textSize = size === 'sm' ? 'text-base' : 'text-lg';
  const textColor = variant === 'light' ? 'text-background-50' : 'text-foreground-950';
  const markBg =
    variant === 'light'
      ? 'bg-background-50 text-primary-800'
      : 'bg-primary-700 text-background-50';

  const content = (
    <span className="inline-flex items-center gap-2.5">
      <span className={`${markSize} ${markBg} flex items-center justify-center shrink-0`}>
        <i className="ri-arrow-left-right-line text-lg" aria-hidden="true" />
      </span>
      {showName ? (
        <span className={`${textSize} font-bold tracking-tight font-heading ${textColor}`}>Monexa</span>
      ) : null}
    </span>
  );

  if (!to) return content;

  return (
    <Link to={to} className="inline-flex items-center cursor-pointer" aria-label="Monexa">
      {content}
    </Link>
  );
}